import { DateTime } from 'luxon';

/**
 * Converts various date representations to JavaScript Date object
 */
export function toJSDate(value: unknown): Date | null {
  if (!value) {
    return null;
  }

  if (DateTime.isDateTime(value)) {
    if (!value.isValid) {
      return null;
    }
    return value.toJSDate();
  }

  if (value instanceof Date) {
    return value;
  }

  if (typeof value === 'string' || typeof value === 'number') {
    const date = new Date(value);
    return isNaN(date.getTime()) ? null : date;
  }

  return null;
}

